export default __webpack_public_path__ + "static/logo1-fa8ea0d7c4d369305fa7527a4c22bf6c.png";